<template>
    <el-button @click="handleCreate">新建</el-button>
    <el-table :data="issueList">
        <el-table-column prop="id" label="ID" width="50" />
        <el-table-column prop="title" label="名称" width="150" />
        <el-table-column label="内容" width="400">
            <template #default="scope">
                <pre style="max-height: 200px; overflow-y: scroll">{{ scope.row.content }}</pre>
            </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150" :formatter="formatDate" />
        <el-table-column prop="update_time" label="更新时间" width="150" :formatter="formatDate" />
        <el-table-column label="操作">
            <template #default="scope">
                <!-- <el-button link type="primary" size="small">详情</el-button> -->
                <el-button link type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            </template>
        </el-table-column>
    </el-table>

    <el-dialog v-model="dialogFormVisible" title="详情" width="800">
        <el-form :model="form">
            <el-form-item label="名称">
                <el-input v-model="form.title" placeholder="" />
            </el-form-item>
            <el-form-item label="内容">
                <el-input v-model="form.content" type="textarea" placeholder="" :autosize="{ minRows: 3, maxRows: 15 }" />
            </el-form-item>
        </el-form>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="handleSave">Confirm</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import * as api from '@/api';

export default {
    data() {
        return {
            dialogFormVisible: false,
            form: {
                id: '',
                title: '',
                content: '',
            },
            issueList: [],
        };
    },

    mounted() {
        this.getIssueList();
    },

    methods: {
        handleCreate() {
            this.form = {
                id: '',
                title: '',
                content: '',
            };
            this.dialogFormVisible = true;
        },

        handleEdit(v) {
            this.form = {
                id: v.id,
                title: v.title,
                content: v.content,
            };
            this.dialogFormVisible = true;
        },

        handleSave() {
            if (this.form.id) {
                this.updateIssue();
            } else {
                this.createIssue();
            }
            this.dialogFormVisible = false;
        },

        getIssueList() {
            api.getIssueList().then(res => {
                this.issueList = res.data;
            });
        },

        updateIssue() {
            const { id, title, content } = this.form;
            api.updateIssue(id, title, content).then(res => {
                this.getIssueList();
            });
        },

        createIssue() {
            const { title, content } = this.form;
            api.createIssue(title, content).then(res => {
                this.getIssueList();
            });
        },

        formatDate(row, column, cellValue, index) {
            return this.$format.YmdHis(cellValue);
        },
    },
};
</script>
../../api
